import { useCallback } from 'react';
import { useCollectPaymentMultiContext } from '../../../../collect-payment-multi.context';
import { PAYMENT_MULTI_STEPS } from '../../../../utils/steps';
import type { CareCreditEnrollDisclosureNavigationProps } from '../care-credit-enroll-disclosure.types';

export const CareCreditEnrollDisclosureGenericNavigation = ({
  body: Body,
}: CareCreditEnrollDisclosureNavigationProps) => {
  const {
    multiStep: { goPrevStep, goNextStep, onCancel: onCancelModal },
    isCareCreditRestrictedState,
    setCareCreditMessageType,
  } = useCollectPaymentMultiContext();

  const onGoBack = useCallback(() => {
    goPrevStep({ orStep: PAYMENT_MULTI_STEPS.paymentMethods });
  }, [goPrevStep]);

  const onCompleteStep = useCallback(() => {
    if (isCareCreditRestrictedState) {
      setCareCreditMessageType('payment-link');
      goNextStep({
        orStep: PAYMENT_MULTI_STEPS.careCreditMessageDisclosure,
      });
    } else {
      goNextStep({ orStep: PAYMENT_MULTI_STEPS.careCreditEnroll });
    }
  }, [goNextStep, isCareCreditRestrictedState]);

  const onVerifyStatus = useCallback(() => {
    goNextStep({ orStep: PAYMENT_MULTI_STEPS.careCreditVerifyStatus });
  }, [goNextStep]);

  const onCancel = useCallback(() => {
    onCancelModal?.();
  }, [onCancelModal]);

  return (
    <Body onGoBack={onGoBack} onCompleteStep={onCompleteStep} onVerifyStatus={onVerifyStatus} onCancel={onCancel} />
  );
};
